import "core-js/modules/es.array.push.js";
const __default__ = {
  name: "GroupEditor",
  data: () => ({
    editData: {
      name: "",
      class_id: false,
      type: "student",
      students: [],
      participants: []
    },
    keywordFilter: "",
    classroomFilter: "",
    studentsList: [],
    participantsList: [],
    dataUpdating: false,
    isLoading: {
      students: false,
      participants: false,
      editData: true
    },
    showCurrentGroup: true,
    showOnlySelected: false,
    selectedStudentCount: 0,
    selectedParticipantCount: 0,
    showCompleteModal: false,
    modalButtonDisabled: false,
    localModalSettings: {
      title: "",
      message: ""
    },
    showConfirmModal: false,
    confirmMessageTitle: "",
    confirmMessage: "",
    error: {
      name: null,
      members: null
    },
    warning: ""
  }),
  head: {
    title: function () {
      return {
        inner: "グループ管理"
      };
    },
    meta: []
  },
  computed: {
    isAllSelected: function () {
      if (this.editData.type === "student") {
        const filteredStudentIds = this.filteredStudentsList.map(v => v.id);
        return this.editData.students.length !== 0 && filteredStudentIds.every(v => this.editData.students.includes(v));
      } else {
        const filteredParticipantIds = this.filteredParticipantsList.map(v => v.id);
        return this.editData.participants.length !== 0 && filteredParticipantIds.every(v => this.editData.participants.includes(v));
      }
    },
    filteredStudentsList: function () {
      let localStudentsList = this.studentsList;

      if (this.showOnlySelected) {
        localStudentsList = localStudentsList.filter(v => this.editData.students.includes(v.id));
      }

      if (this.classroomFilter) {
        localStudentsList = localStudentsList.filter(v => v.class_id === this.classroomFilter);
      }

      if (this.keywordFilter) {
        localStudentsList = localStudentsList.filter(v => v.name.indexOf(this.keywordFilter) > -1);
      }

      return localStudentsList;
    },
    filteredParticipantsList: function () {
      let localParticipantsList = this.participantsList;

      if (this.showOnlySelected) {
        localParticipantsList = localParticipantsList.filter(v => this.editData.participants.includes(v.id));
      }

      if (this.keywordFilter) {
        localParticipantsList = localParticipantsList.filter(v => v.name.indexOf(this.keywordFilter) > -1);
      }

      localParticipantsList = localParticipantsList.sort((a, b) => {
        if (a.belonging === null && b.belonging === null) {
          if (a.ruby && b.ruby) {
            if (a.ruby < b.ruby) return -1;
            if (a.ruby > b.ruby) return 1;
          }
        }

        if (a.belonging !== null && b.belonging === null) return -1;
        if (a.belonging === null && b.belonging !== null) return 1;
        if (a.belonging < b.belonging) return -1;
        if (a.belonging > b.belonging) return 1;

        if (a.ruby && b.ruby) {
          if (a.ruby < b.ruby) return -1;
          if (a.ruby > b.ruby) return 1;
        }

        return 0;
      });
      return localParticipantsList;
    }
  },
  watch: {
    filteredStudentsList: function (val) {
      const ids = val.map(v => v.id);

      if (this.editData.type === "student") {
        if (this.editData.students.find(v => !ids.includes(v))) {
          this.warning = "表示されていない" + this.studentAddress + "がグループに含まれています";
        } else {
          this.warning = "";
        }
      }
    },
    filteredParticipantsList: function (val) {
      if (this.editData.type === "participant") {
        const ids = val.map(v => v.id);

        if (this.editData.participants.find(v => !ids.includes(v))) {
          this.warning = "表示されていない関係者がグループに含まれています";
        } else {
          this.warning = "";
        }
      }
    },
    "editData.type": function (val) {
      if (val === "student") {
        this.selectedParticipantCount = 0;
        this.editData.participants = [];
      } else if (val === "participant") {
        this.selectedStudentCount = 0;
        this.editData.students = [];
      }
    }
  },

  created() {
    if (this.isEditMode) {
      getData("reader/get_group_with_students/" + this.$route.params.id).then(data => {
        this.editData.name = data.items.group.name;
        this.editData.type = data.items.group.type;
        this.editData.class_id = data.items.group.class_id;
        this.editData.students = data.items.students;
        this.editData.participants = data.items.participants;
      }).catch(error => {
        console.log(error);
      }).then(() => {
        this.isLoading.editData = false;
      });
    }

    this.getStudents();
    this.getParticipants();
  },

  methods: {
    saveData() {
      let valid = true;
      this.error = {
        name: null,
        members: null
      };

      if (!this.editData.name) {
        this.error.name = "グループ名を入力してください。";
        valid = false;
      }

      if (this.editData.name.length > 20) {
        this.error.name = "グループ名を20文字以下にしてください";
        valid = false;
      }

      if (this.groups.find(v => v.id !== this.$route.params.id && v.name === this.editData.name)) {
        this.error.name = "既存のグループと重複しています。";
        valid = false;
      }

      if (this.editData.type === "student" && this.editData.students.length === 0 || this.editData.type === "participant" && this.editData.participants.length === 0) {
        this.error.members = "選択してください。";
        valid = false;
      }

      if (!valid) {
        return;
      }

      this.dataUpdating = true;
      new Promise((resolve, reject) => {
        if (this.isEditMode) {
          updateData("writer/write_group/" + this.$route.params.id, this.editData).then(() => {
            this.localModalSettings = {
              title: "更新完了",
              message: "グループ更新が完了しました。"
            };
            resolve();
          }).catch(() => {
            this.localModalSettings = {
              title: "登録失敗",
              message: "グループ登録に失敗しました。"
            };
            reject();
          });
        } else {
          createData("writer/write_group", this.editData).then(() => {
            this.localModalSettings = {
              title: "登録完了",
              message: "グループ登録が完了しました。"
            };
            resolve();
          }).catch(() => {
            this.localModalSettings = {
              title: "登録失敗",
              message: "グループ登録に失敗しました。"
            };
            reject();
          });
        }
      }).then(() => {
        return getData("groups");
      }).then(data => {
        this.groups = data.items;
        this.showCompleteModal = true;
      });
    },

    confirmDelete() {
      this.confirmMessageTitle = "グループ削除";
      this.confirmMessage = "グループを削除します。\n本当によろしいですか？";
      this.showConfirmModal = true;
    },

    cancelConfirm() {
      this.showConfirmModal = false;
    },

    handleDeleteData() {
      this.dataUpdating = true;
      this.showConfirmModal = false;
      deleteData("eraser/delete_group/" + this.$route.params.id).then(() => {
        this.localModalSettings = {
          title: "削除完了",
          message: "グループ削除が完了しました。"
        };
        return getData("groups");
      }).catch(error => {
        this.localModalSettings = {
          title: "削除失敗",
          message: "グループ削除に失敗しました。"
        };
        console.log(error);
      }).then(data => {
        this.groups = data.items;
        this.showCompleteModal = true;
      });
    },

    completeCreate() {
      this.$router.push({
        name: "groups"
      });
    },

    completeRefresh() {
      this.$router.push({
        name: "groups"
      });
    },

    getStudents() {
      this.isLoading.students = true;
      this.editData.students = [];
      this.studentsList = [];
      getData("students?with[]=group" + (this.editData.class_id ? "&classrooms=" + this.editData.class_id : "")).then(data => {
        this.studentsList = data.items;
      }).catch(error => {
        console.log(error);
      }).then(() => {
        this.isLoading.students = false;
      });
    },

    getParticipants() {
      this.isLoading.participants = true;
      this.editData.participants = [];
      this.participantsList = [];
      getData("participants?with[]=group").then(data => {
        this.participantsList = data.items;
      }).catch(error => {
        console.log(error);
      }).then(() => {
        this.isLoading.participants = false;
      });
    },

    getCurrentClassName(id) {
      const classroom = this.classrooms.filter(v => v.id === id)[0];
      return classroom ? classroom.name : "";
    },

    changeAll(e) {
      if (e.target.checked) {
        if (this.editData.type === "student") {
          this.editData.students = this.filteredStudentsList.map(v => v.id);
        } else if (this.editData.type === "participant") {
          this.editData.participants = this.filteredParticipantsList.map(v => v.id);
        }
      } else if (!e.target.checked) {
        if (this.editData.type === "student") {
          this.editData.students = [];
        } else if (this.editData.type === "participant") {
          this.editData.participants = [];
        }
      }
    }

  }
};
import { computed } from "vue";
import { useRoute } from "vue-router/composables";
import { useStore } from "vue2-helpers/vuex";
import { createData, deleteData, getData, updateData } from "@/services/axios";
import LoadingMessage from "@/components/common/LoadingMessage";
import MessageModal from "@/components/common/MessageModal.vue";
import ConfirmModal from "@/components/common/ConfirmModal";
import RowItem from "@/components/RowItem";
import { storeToRefs } from "pinia";
import { useGradeClassroomStore } from "@/stores/gradeClassroom";
import { useGroupStore } from "@/stores/group";
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props, {
    expose
  }) {
    const {
      groups
    } = storeToRefs(useGroupStore());
    const {
      classrooms
    } = storeToRefs(useGradeClassroomStore());
    const route = useRoute();
    const store = useStore();
    const studentAddress = computed(() => store.state.studentAddress);
    const grades = computed(() => store.state.grades);
    const isEditMode = computed(() => route.params.id);
    expose({
      groups,
      classrooms,
      isEditMode,
      studentAddress,
      grades
    });
    return {
      __sfc: true,
      groups,
      classrooms,
      route,
      store,
      studentAddress,
      grades,
      isEditMode,
      LoadingMessage,
      MessageModal,
      ConfirmModal,
      RowItem
    };
  }

});